const form2 = {
  formId2: "new-user-form-2",
  formField2: {
    quarter: {
      name: "quarter",
      label: "[01] Kỳ tính thuế: Quý",
      type: "number",
      placeholder: "",
      errorMsg: "Vui lòng nhập quý",
    },
    year: {
      name: "year",
      label: "Năm",
      type: "number",
      placeholder: "",
      errorMsg: "Vui lòng nhập năm",
    },
    name: {
      name: "name",
      label: "[02] Tên người nộp thuế:",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng nhập tên người nộp thuế",
    },
    taxId: {
      name: "taxId",
      label: "[03] Mã số thuế:",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng nhập mã số thuế",
      invalidMsg: "Mã số thuế không hợp lệ",
    },
  },
};

export default form2;
